import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n/LocalizationProvider';
import { useAuth } from '../auth/AuthContext';
import { getCredentialHints } from '../auth/authStore';

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { t } = useTranslation();
  const { login } = useAuth();
  const credentials = getCredentialHints();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setError(false);

    try {
      const session = login(username, password);
      if (!session) {
        throw new Error('Invalid credentials');
      }
      if (session.role === 'admin') {
        navigate('/admin');
      } else if (session.role === 'user') {
        navigate('/org');
      } else {
        navigate('/subuser');
      }
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel" style={{ maxWidth: 520, margin: '0 auto' }}>
      <div className="section-heading" style={{ marginBottom: '1rem' }}>
        <div>
          <span className="badge">{t('login.badge')}</span>
          <h2>{t('login.title')}</h2>
          <p className="text-muted">{t('login.description')}</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="form-grid">
        <label>
          <span className="text-muted">{t('login.username')}</span>
          <input
            type="text"
            value={username}
            onChange={event => setUsername(event.target.value)}
            autoComplete="username"
            required
          />
        </label>
        <label>
          <span className="text-muted">{t('login.password')}</span>
          <input
            type="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        {error && <p className="text-muted" style={{ color: '#c13a3a' }}>{t('login.error')}</p>}
        <button type="submit" disabled={loading}>
          {loading ? t('login.loading') : t('login.submit')}
        </button>
      </form>

      <div className="panel" style={{ boxShadow: 'none', marginTop: '1.5rem' }}>
        <h3>{t('login.demo.title')}</h3>
        <p className="text-muted">{t('login.demo.description')}</p>
        <table>
          <thead>
            <tr>
              <th>{t('login.demo.table.role')}</th>
              <th>{t('login.demo.table.username')}</th>
              <th>{t('login.demo.table.password')}</th>
            </tr>
          </thead>
          <tbody>
            {credentials.map(cred => (
              <tr key={cred.username}>
                <td>{t(`layout.roles.${cred.role}`)}</td>
                <td>{cred.username}</td>
                <td>{cred.password}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
